import { Grid } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import WSDataGrid, { IColumns } from "../../Components/DataGrid/WSDataGrid";
import ConfirmationPopup from "../../Components/Confirmation/Confirmation";
import { useDispatch } from "react-redux";
import { resetDataComponent } from "../../StateManagement/actions";
import { useSnackbar } from "../../Components/Snackbar/SnackBarContext";

import { updateMainHeader } from "../../commonFunctions/CommonFunctions";
import { breadCrumbsStore } from "../../Components/BreadCrumbs/BreadCrumbsListner";
import { useReactToPrint } from "react-to-print";
import WSBarcodeLabel from "../../Components/BarCode/WSBarCodeLabel";
import { IRows } from "../../Components/Filter/WSFilterComponent";

export const ProductList: React.FC<any> = React.memo((props) => {
    const navigate = useNavigate();

    const [selectedId, setSelectedId] = useState<string | number>(0);
    const [isPopupOpen, setPopupOpen] = useState(false);
    const [printData, setPrintData] = useState<any>(null);
    const [printCount, setPrintCount] = useState<number>(2); // how many labels

    const [selectedRows, setSelectedRows] = useState<any[]>([]);

    const dispatch = useDispatch();
    const { showMessage } = useSnackbar();

    const printRef = useRef<HTMLDivElement>(null);

    const handlePrint = useReactToPrint({
        contentRef: printRef
    });

    const filters = ['All Records'];
    // const [selectedFilter, setSelectedFilter] = useState(filters[0]);

    const source = {
        url: "Vyapar/Product/search",
        page: 1,
        pageSize: 10,
        filter: [],
        sort: [],
    };

    useEffect(() => {
        updateMainHeader('Product');
    })

    breadCrumbsStore.updateBreadCrumbs([
        { 'Product List': '/product/list' },
    ]);

    // const handleFilter = (value: any) => {
    //     let soureFilter: any = {
    //         url: "Vyapar/Product/search",
    //         page: 1,
    //         pageSize: 10,
    //         filter: [
    //         ],
    //         sort: [
    //             {
    //                 "field": "UpdatedAt",
    //                 "direction": "desc"
    //             }
    //         ],
    //     }
    //     switch (value) {
    //         case 'In Stock':
    //             soureFilter.filter = [{
    //                 "field": "name",
    //                 "operator": "eq",
    //                 "value": "In Stock"
    //             }]
    //             break

    //     }
    // }

    const handleBulkSelection = (rows: any[]) => {
        setSelectedRows(rows);
    };

    const handleAction = (action: string, row: any) => {

        if (action === "Edit") {
            navigate(`/item-products/${row.id}`);
        }
        else if (action === "Delete") {
            setSelectedId(row.id);
            setPopupOpen(true);
        }
        else if (action === "Print BarCode") {

            const barcode = row.barcodes[0].barcode;
            const name = row.name;
            const itemCode = row.itemCode;
            const price = row.salePrice;
            const companyName = "Rangoli collections";

            if (!barcode) {
                console.warn("No barcode found for this product");
                return;
            }

            setPrintData({
                companyName,
                barcode,
                name,
                itemCode,
                price
            });

            setPrintCount(2);

            setTimeout(() => {
                handlePrint();
            }, 200);
        }
    };

    const handleBulkPrint = () => {

        if (!selectedRows.length) {
            console.warn("No products selected");
            return;
        }

        const companyName = "Rangoli collections";

        const labels = selectedRows.map((row) => ({
            companyName,
            barcode: row.barcodes?.[0]?.barcode,
            name: row.name,
            itemCode: row.itemCode,
            price: row.salePrice
        }));

        setPrintData(labels);

        setTimeout(() => {
            handlePrint();
        }, 200);
    };

    const filterRows: IRows[] = [
        {
            label: "Product Name",
            fieldName: "name",
            type: "text",
            operator: "like",
            rowDivision: 6
        },

        {
            label: "Item Code",
            fieldName: "itemCode",
            type: "text",
            operator: "like",
            rowDivision: 6
        },
    ];

    const columns: IColumns[] = [
        // {
        //     header: "Image",
        //     fieldName: "imageUrl",
        //     type: "img",
        // },
        {
            header: "Name",
            fieldName: "name",
            tooltip: true,
            sortable: true,
        },
        {
            header: "Item Code",
            fieldName: "itemCode",
        },
        {
            header: "Category",
            fieldName: "categoryName",
        },
        // {
        //     header: "Brand",
        //     fieldName: "brand",
        // },

        {
            header: "Purchase Price",
            fieldName: "purchasePrice",
            sortable: true,
            type: "amount",
        },
        {
            header: "Sale Price",
            fieldName: "salePrice",
            sortable: true,
            type: "amount",
        },
        // {
        //     header: "GST %",
        //     fieldName: "gstPercent",
        // },

        // {
        //     header: "Status",
        //     fieldName: "status",
        //     type: "status",
        // },
        {
            header: "Actions",
            fieldName: "actions",
            type: "action",
            actions: ["Edit","Delete", "Print BarCode"],
            actionCallback: handleAction,
        },
    ];

    const handleClick = () => {
        navigate("/product");
    };

    return (
        <Grid p={3}>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    {/* <Button
                        variant="contained"
                        size="small"
                        onClick={handleBulkPrint}
                    >
                        Print Selected Barcodes
                    </Button> */}

                    <WSDataGrid
                        id="productGrid"
                        title="Product"
                        columns={columns}
                        source={source}
                        filterFields={filterRows}
                        rowsPerPageCount={10}
                        searchBox={{ fieldName: 'name' }}
                        addButton={{ label: "Add Product", showIcon: true }}
                        onAddButtonClick={handleClick}
                        // multiSelect={true}
                        // onSelectionChange={handleBulkSelection}
                        gridHeaderSx={{
                            backgroundColor: "whitesmoke",
                            border: "1px solid whitesmoke",
                        }}
                    />
                </Grid>

                <ConfirmationPopup
                    type="DELETE"
                    apiUrl="Vyapar/Product"
                    id={selectedId}
                    confirmMessage="Are you sure you want to delete this product?"
                    open={isPopupOpen}
                    onClose={() => setPopupOpen(false)}
                    onConfirm={(data: any) => {
                        console.log("Delete response:", data);
                        dispatch(resetDataComponent("productGrid"));
                        if (data.success === true) {
                            showMessage(data?.message, "success");
                        } else {
                            showMessage(data?.message, "error");
                        }
                    }}
                />

                <div style={{ display: "none" }}>
                    {printData && (<div ref={printRef} style={{ display: "flex", flexWrap: "wrap", gap: 10 }}>
                        {Array.from({ length: printCount }).map((_, index) => (<WSBarcodeLabel key={index}
                            companyName={printData.companyName}
                            barcode={printData.barcode}
                            name={printData.name}
                            itemCode={printData.itemCode}
                            price={printData.price} />))}
                    </div>)}
                </div>
            </Grid>
        </Grid>
    );
});
